import { keyBy } from "lodash";

import { IDeviceListItem } from "interfaces/entities/devices";
import {
  CRUDAction,
  IEntityDeleteSuccess,
  IEntityFetchCollectionSuccess,
  IEntityUpdateSuccess,
  RequestAction,
} from "store/entities/actions";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IEntityCollectionState } from "store/entities/reducer";
import { IActionWithPayload } from "store/helper";

import { AGENT, AgentAction, AgentActionsNames } from "./actions";
import {
  IAgent,
  IBatchCreateAgentsSuccessPayload,
  IChangeAutoAssignmentSuccessPayload,
  IFetchSingleAgentSuccessPayload,
  IFinishWelcomeTutorialPayload,
} from "./interfaces";

const initialState = {};

export const agentsReducer = (
  state: IEntityCollectionState<IAgent> = initialState,
  action: AgentAction
): IEntityCollectionState<IAgent> => {
  switch (action.type) {
    case AGENT[CRUDAction.FETCH_SINGLE][RequestAction.SUCCESS]: {
      const { payload } = action as IActionWithPayload<string, IFetchSingleAgentSuccessPayload>;
      const { value: agent } = payload;

      return {
        ...state,
        [agent.id]: agent,
      };
    }

    case AGENT[CRUDAction.FETCH_COLLECTION][RequestAction.SUCCESS]: {
      // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'AgentAc... Remove this comment to see the full error message
      const { values } = action.payload as IEntityFetchCollectionSuccess<IAgent>;
      return keyBy(values, v => v.id);
    }

    case AGENT.CREATE_BATCH[RequestAction.SUCCESS]: {
      // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'AgentAc... Remove this comment to see the full error message
      const { agents } = action.payload as IBatchCreateAgentsSuccessPayload;
      return {
        ...state,
        ...keyBy(agents, v => v.id),
      };
    }

    case AGENT[CRUDAction.UPDATE][RequestAction.SUCCESS]: {
      // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'AgentAc... Remove this comment to see the full error message
      const { value: agent } = action.payload as IEntityUpdateSuccess<IAgent>;
      // @ts-expect-error TS(2322): Type '{ [x: string]: IAgent | undefined; }' is not... Remove this comment to see the full error message
      return {
        ...state,
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        [agent.id]: agent,
      };
    }

    case AGENT.SET_FLAG[RequestAction.SUCCESS]: {
      // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'AgentAc... Remove this comment to see the full error message
      const { id, name: combinedName, value } = action.payload as { id: string; name: string; value: boolean | string };
      const [name] = combinedName.split("_");

      if (!state[id]) {
        return state;
      }

      return {
        ...state,
        [id]: {
          ...state[id],
          flags: {
            ...state[id].flags,
            [name]: value,
          },
        },
      };
    }

    case AGENT.CHANGE_THEME[RequestAction.SUCCESS]: {
      // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'AgentAc... Remove this comment to see the full error message
      const { agent } = action.payload as { agent: IAgent };

      return {
        ...state,
        [agent.id]: {
          ...state[agent.id],
          settings: {
            ...state[agent.id].settings,
            theme: agent.settings.theme,
          },
        },
      };
    }

    case AGENT.CHANGE_AUTO_ASSIGNMENT[RequestAction.SUCCESS]: {
      const { payload } = action as IActionWithPayload<string, IChangeAutoAssignmentSuccessPayload>;
      const { agentId, autoassignment } = payload;

      return {
        ...state,
        [agentId]: {
          ...state[agentId],
          autoassignment,
        },
      };
    }

    case AGENT.SUBSCRIBE_DEVICE[RequestAction.SUCCESS]: {
      // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'AgentAc... Remove this comment to see the full error message
      const { agentId, deviceSubscription } = action.payload as {
        agentId: string;
        deviceSubscription: IDeviceListItem;
      };

      return {
        ...state,
        [agentId]: {
          ...state[agentId],
          // @ts-expect-error TS(2488): Type 'IDeviceListItem[] | undefined' must have a '... Remove this comment to see the full error message
          webpushSubscriptions: [...state[agentId].webpushSubscriptions, deviceSubscription],
        },
      };
    }

    case AGENT.UNSUBSCRIBE_DEVICE[RequestAction.SUCCESS]: {
      // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'AgentAc... Remove this comment to see the full error message
      const { agentId, deviceId } = action.payload as {
        agentId: string;
        deviceId: string;
      };

      return {
        ...state,
        [agentId]: {
          ...state[agentId],
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          webpushSubscriptions: state[agentId].webpushSubscriptions.filter(item => item.ID !== deviceId),
        },
      };
    }

    case AGENT.FINISH_WELCOME_TUTORIAL[RequestAction.REQUEST]: {
      // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'AgentAc... Remove this comment to see the full error message
      const { id } = action.payload as IFinishWelcomeTutorialPayload;
      return {
        ...state,
        // @ts-expect-error TS(2464): A computed property name must be of type 'string',... Remove this comment to see the full error message
        [id]: {
          // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
          ...state[id],
          flags: {
            // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
            ...state[id].flags,
            visitedWelcomeTutorial: true,
          },
        },
      };
    }

    case AGENT[CRUDAction.DELETE][RequestAction.SUCCESS]:
    case AgentActionsNames.SYNC_DELETE: {
      // @ts-expect-error TS(2339): Property 'payload' does not exist on type 'AgentAc... Remove this comment to see the full error message
      const { id } = action.payload as IEntityDeleteSuccess;
      const newState = { ...state };
      // @ts-expect-error TS(2538): Type 'undefined' cannot be used as an index type.
      delete newState[id];
      return newState;
    }

    default:
      return state;
  }
};
